import React from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  className?: string;
  width?: string;
  height?: string;
};

const Hearth: React.FC<Props> = ({ className, fill = 'none', stroke = '#0B1215', width = '22', height = '22' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 22 22" fill={fill}>
    <path
      d="M19.1031 4.22555C18.6349 3.75714 18.079 3.38556 17.4672 3.13205C16.8554 2.87853 16.1996 2.74805 15.5373 2.74805C14.875 2.74805 14.2192 2.87853 13.6074 3.13205C12.9955 3.38556 12.4396 3.75714 11.9715 4.22555L10.9998 5.19722L10.0281 4.22555C9.0824 3.27984 7.79973 2.74854 6.46228 2.74854C5.12484 2.74854 3.84217 3.27984 2.89645 4.22555C1.95073 5.17127 1.41943 6.45394 1.41943 7.79139C1.41943 9.12883 1.95073 10.4115 2.89645 11.3572L3.86812 12.3289L10.9998 19.4606L18.1315 12.3289L19.1031 11.3572C19.5715 10.889 19.9431 10.3331 20.1966 9.7213C20.4501 9.10946 20.5806 8.45367 20.5806 7.79139C20.5806 7.12911 20.4501 6.47332 20.1966 5.86148C19.9431 5.24964 19.5715 4.69375 19.1031 4.22555Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Hearth;
